import initSpacer from './init-spacer';

export default {
  initSpacer,
};
